import { useState } from "react";
export const usePagination = (opts) => {
    const { rowsPerPage, totalRows } = opts;
    const [visiblePages, setVisiblePages] = useState(1);
    const visibleRows = visiblePages * rowsPerPage;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const showMore = () => {
        setVisiblePages((pages) => {
            if (pages < totalPages) {
                return pages + 1;
            }
            return pages;
        });
    };
    if (visiblePages > totalPages && totalPages > 0) {
        setVisiblePages(totalPages);
    }
    const rowsLeft = totalRows - visibleRows;
    return {
        showMore,
        visibleRows,
        rowsLeft,
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlUGFnaW5hdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1Jlc291cmNlTGlzdC9ob29rcy91c2VQYWdpbmF0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxRQUFRLEVBQUUsTUFBTSxPQUFPLENBQUM7QUFhakMsTUFBTSxDQUFDLE1BQU0sYUFBYSxHQUFHLENBQzNCLElBQTBCLEVBQ0wsRUFBRTtJQUN2QixNQUFNLEVBQUUsV0FBVyxFQUFFLFNBQVMsRUFBRSxHQUFHLElBQUksQ0FBQztJQUN4QyxNQUFNLENBQUMsWUFBWSxFQUFFLGVBQWUsQ0FBQyxHQUFHLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQztJQUNwRCxNQUFNLFdBQVcsR0FBRyxZQUFZLEdBQUcsV0FBVyxDQUFDO0lBRS9DLE1BQU0sVUFBVSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUMsU0FBUyxHQUFHLFdBQVcsQ0FBQyxDQUFDO0lBRXRELE1BQU0sUUFBUSxHQUFHLEdBQVMsRUFBRTtRQUMxQixlQUFlLENBQUMsQ0FBQyxLQUFLLEVBQUUsRUFBRTtZQUN4QixJQUFJLEtBQUssR0FBRyxVQUFVLEVBQUUsQ0FBQztnQkFDdkIsT0FBTyxLQUFLLEdBQUcsQ0FBQyxDQUFDO1lBQ25CLENBQUM7WUFDRCxPQUFPLEtBQUssQ0FBQztRQUNmLENBQUMsQ0FBQyxDQUFDO0lBQ0wsQ0FBQyxDQUFDO0lBRUYsSUFBSSxZQUFZLEdBQUcsVUFBVSxJQUFJLFVBQVUsR0FBRyxDQUFDLEVBQUUsQ0FBQztRQUNoRCxlQUFlLENBQUMsVUFBVSxDQUFDLENBQUM7SUFDOUIsQ0FBQztJQUVELE1BQU0sUUFBUSxHQUFHLFNBQVMsR0FBRyxXQUFXLENBQUM7SUFFekMsT0FBTztRQUNMLFFBQVE7UUFDUixXQUFXO1FBQ1gsUUFBUTtLQUNULENBQUM7QUFDSixDQUFDLENBQUMifQ==